/* eslint-disable no-param-reassign */
// import axios from '@axios'
// import useJwt from '@/auth/jwt/useJwt'

export default {
  namespaced: true,
  state: {
    classData: null,
    baseUrl: '',
  },
  getters: {
  },
  mutations: {
    UPDATE_CLASS_DATA(state, val) {
      state.classData = val
    },
    UPDATE_BASE_URL(state, val) {
      state.baseUrl = val
    },
  },
  actions: {
  },
}
